import { EmbeddedViewRef } from "@angular/core";

export class Alert {
  type: AlertType;
  customData: string;
  message: string;
  viewRef: EmbeddedViewRef<any>;
}

export enum AlertType {
  Success,
  Error,
  Info,
  Warning
}


// WEBPACK FOOTER //
// ./src/app/exa/_models/alert.ts